<template>
  <!-- 冰柜领用订单的明细显示可能会有不同的地方，可以考虑单独做一个组件或者增加一个prop传递参数用于区别展示 -->
  <el-table :data="detailList" :show-header="false" class="order-detail">
    <el-table-column label="图片" width="100">
      <template slot-scope="scope">
        <div class="item-image">
          <img :src="getImageUrl(scope.row.pocmDTO)" />
        </div>
      </template>
    </el-table-column>
    <el-table-column label="名称" width="250">
      <template slot-scope="scope">
        <div class="item-name">{{ scope.row.itemName }}</div>
      </template>
    </el-table-column>
    <el-table-column label="状态" width="240" v-if="orderInfo.orderTypeName !== 'shopSign'">
      <template slot-scope="scope">状态: {{ scope.row.detailStatusName }}</template>
    </el-table-column>
    <el-table-column label="MMR12" width="240">
      <template slot-scope="scope">MMR12: {{ scope.row.mmr12 }}</template>
    </el-table-column>
    <el-table-column label="数量">
      <template slot-scope="scope">数量: {{ scope.row.purchaseQuantity | thousandSymbol}}</template>
    </el-table-column>
    <el-table-column label="小计">
      <div class="item-sum">小计: ￥{{ orderInfo.itemAmount | thousandSymbol}}</div>
      <!-- <div class="item-sum" v-else="!orderInfo.subOrderList || orderInfo.subOrderList.length === 0">小计: {{ orderInfo.itemAmount }}</div> -->
      <!-- <div class="item-sum">小计: {{ getItemSumPrice(scope.row) }}</div> -->
    </el-table-column>
  </el-table>
</template>

<script>
import { commonUtils } from '@/utils/common'
import { create, all } from 'mathjs/number'
const math = create(all)
export default {
  name: 'order-line-detail',
  props: {
    detailList: {
      type: Array,
      default: () => {
        return []
      }
    },
    orderInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  methods: {
    getItemSumPrice (item) {
      if (!item) {
        return ''
      }
      let sum = commonUtils.formatNumber(
        math.multiply(item.purchasePrice, item.purchaseQuantity / item.pocmDTO.priceUnitQuantity)
      ).toFixed(2)
      sum = Number(sum) ? sum : 0.01
      return sum
    },
    getImageUrl (item) {
      let imageUri = ''
      if (item.imageList && item.imageList.length > 0) {
        imageUri = item.imageList[0].imageFileUri
      }
      return commonUtils.getImageUrl(imageUri)
    },
    getBrandName (row) {
      if (row.subBrandName) {
        return row.abiBrandName + ' - ' + row.subBrandName
      }
      return row.abiBrandName
    },
    getChannelName (row) {
      if (row.subChannelName) {
        return row.channelName + ' - ' + row.subChannelName
      }
      return row.channelName
    }
  }
}
</script>

<style lang="scss" scoped>
.order-detail {
  .item-image {
    width: 72px;
    height: 72px;
    margin: 0 auto;
    border: 1px solid $base-grey;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    img {
      max-width: 90%;
      max-height: 90%;
    }
  }

  .item-name {
    text-align: left;
    font-weight: 700;
  }

  .item-sum {
    font-weight: 700;
  }
}
</style>
